var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSms(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0735 11.1618H12.9265V5.82353H11.0735V11.1618ZM12 14.6471C12.2794 14.6471 12.5112 14.5553 12.6953 14.3718C12.8788 14.1876 12.9706 13.9632 12.9706 13.6985C12.9706 13.4191 12.8788 13.1874 12.6953 13.0032C12.5112 12.8197 12.2794 12.7279 12 12.7279C11.7206 12.7279 11.4891 12.8197 11.3056 13.0032C11.1215 13.1874 11.0294 13.4191 11.0294 13.6985C11.0294 13.9632 11.1215 14.1876 11.3056 14.3718C11.4891 14.5553 11.7206 14.6471 12 14.6471ZM3 21V5.00735C3 4.44853 3.19471 3.97412 3.58412 3.58412C3.97412 3.19471 4.44853 3 5.00735 3H18.9926C19.5515 3 20.0259 3.19471 20.4159 3.58412C20.8053 3.97412 21 4.44853 21 5.00735V15.4632C21 16.0221 20.8053 16.4965 20.4159 16.8865C20.0259 17.2759 19.5515 17.4706 18.9926 17.4706H6.52941L3 21ZM5.00735 16.3235L5.84559 15.4632H18.9926V5.00735H5.00735V16.3235Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSms);
export default __webpack_public_path__ + "static/media/sms.976cce29cd20569c0a8ead2bbd9a850c.svg";
export { ForwardRef as ReactComponent };